<h2 matDialogTitle>{{prompt.title}}</h2>

<mat-dialog-content>
  {{prompt.description}}
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>{{prompt.close}}</button>
  <button mat-button [matDialogClose]="true">{{prompt.confirm}}</button>
</mat-dialog-actions>